// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.maplight-logo-container {
  background-color: white;
  border-bottom: 12px solid #f3ab3c;
  text-align: center;
}
.maplight-logo-container .gradient-border {
  background: radial-gradient(40% 100% at center, #378249, #f3ab3c);
  height: 4px;
}
.maplight-logo-container img {
  height: 30px;
  margin-bottom: 15px;
}
.maplight-logo-container p {
  color: #5d5d5d;
  margin-top: 15px;
  margin-bottom: 0px;
  padding: 0px 0px 0px 0px;
}

.footer {
  background-color: #474747;
  font-size: 0.9em;
  height: 325px;
}
.footer li {
  color: white;
  list-style: none;
}
.footer a {
  color: white;
}
.footer .container {
  width: 100%;
  padding: 0% 15%;
  padding-bottom: 5%;
  height: -moz-fit-content;
  height: fit-content;
  background-color: #474747;
  max-width: 100%;
}
.footer .container .col-sm-4 {
  max-width: 25%;
  height: -moz-fit-content;
  height: fit-content;
  width: 25%;
}
.footer .container .col-sm-4 ul {
  padding: 0;
  margin: 0;
  width: -moz-fit-content;
  width: fit-content;
}
.footer .container #col2, .footer .container #col3, .footer .container #col4 {
  padding-top: 6em;
}
@media screen and (min-width: 800px) and (max-width: 1199px) {
  .footer .container .col-sm-4 {
    min-width: 33%;
    width: 33%;
    display: block;
  }
  .footer .container #col4 {
    padding-top: 0%;
  }
}
@media screen and (min-width: 450px) and (max-width: 799px) {
  .footer .container .col-sm-4 {
    min-width: 50%;
    width: 50%;
    display: block;
  }
  .footer .container #col3, .footer .container #col4 {
    padding-top: 0%;
  }
}
@media screen and (min-width: 0px) and (max-width: 449px) {
  .footer .container .col-sm-4 {
    min-width: 100%;
    width: 100%;
    display: block;
  }
  .footer .container #col2, .footer .container #col3, .footer .container #col4 {
    padding-top: 0%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/app-footer/app-footer.component.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,iCAAA;EACA,kBAAA;AACF;AAAE;EACE,iEAAA;EACA,WAAA;AAEJ;AAAE;EACE,YAAA;EACA,mBAAA;AAEJ;AAAE;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,wBAAA;AAEJ;;AACA;EACE,yBAAA;EACA,gBAAA;EACA,aAAA;AAEF;AAAE;EACE,YAAA;EACA,gBAAA;AAEJ;AACE;EACE,YAAA;AACJ;AAEE;EACE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,wBAAA;EAAA,mBAAA;EACA,yBAAA;EACA,eAAA;AAAJ;AAEI;EACE,cAAA;EACA,wBAAA;EAAA,mBAAA;EACA,UAAA;AAAN;AAEM;EACE,UAAA;EACA,SAAA;EACA,uBAAA;EAAA,kBAAA;AAAR;AAII;EACE,gBAAA;AAFN;AAME;EAEI;IACE,cAAA;IACA,UAAA;IACA,cAAA;EALN;EAOI;IACE,eAAA;EALN;AACF;AAQE;EAEI;IACE,cAAA;IACA,UAAA;IACA,cAAA;EAPN;EASI;IACE,eAAA;EAPN;AACF;AAUE;EAEI;IACE,eAAA;IACA,WAAA;IACA,cAAA;EATN;EAWI;IACE,eAAA;EATN;AACF","sourcesContent":[".maplight-logo-container {\n  background-color: white;\n  border-bottom: 12px solid #f3ab3c;\n  text-align: center;\n  .gradient-border {\n    background: radial-gradient(40% 100% at center, #378249, #f3ab3c);\n    height: 4px;\n  }\n  img {\n    height: 30px;\n    margin-bottom: 15px;\n  }\n  p {\n    color: #5d5d5d;\n    margin-top: 15px;\n    margin-bottom: 0px;\n    padding: 0px 0px 0px 0px;\n  }\n}\n.footer{\n  background-color: #474747;\n  font-size: 0.9em;\n  height: 325px;\n\n  li {\n    color: white;\n    list-style: none;\n  }\n\n  a {\n    color: white;\n  }\n\n  .container {\n    width: 100%;\n    padding: 0% 15%;\n    padding-bottom: 5%;\n    height: fit-content;\n    background-color: #474747;\n    max-width: 100%;\n\n    .col-sm-4 {\n      max-width: 25%;\n      height: fit-content;\n      width: 25%;\n      \n      ul{\n        padding: 0;\n        margin: 0;\n        width: fit-content;\n      }\n    }\n  \n    #col2, #col3, #col4 {\n      padding-top: 6em;\n    }\n  }\n\n  @media screen and (min-width: 800px) and (max-width: 1199px) {\n    .container{\n      .col-sm-4{\n        min-width: 33%;\n        width: 33%;\n        display: block;\n      }\n      #col4 {\n        padding-top: 0%;\n      }\n    }\n  }\n  @media screen and (min-width: 450px) and (max-width: 799px) {\n    .container{\n      .col-sm-4{\n        min-width: 50%;\n        width: 50%;\n        display: block;\n      }\n      #col3, #col4 {\n        padding-top: 0%;\n      }\n    }\n  }\n  @media screen and (min-width: 0px) and (max-width: 449px) {\n    .container{\n      .col-sm-4{\n        min-width: 100%;\n        width: 100%;\n        display: block;\n      }\n      #col2, #col3, #col4 {\n        padding-top: 0%;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
